/**
 * Log providers
 */
enum ProviderType {
  DATADOG = 'DATADOG',
  SEGMENT = 'SEGMENT'
}

/**
 * Log levels
 */
enum LogLevel {
  ERROR = 'ERROR',
  INFO = 'INFO'
}

/**
 * Provider configuration
 */
type ProviderConfig = {
  logLevel: LogLevel
  isAction: boolean
}

export { ProviderType, LogLevel }
export type { ProviderConfig }
